module.exports = __webpack_public_path__ + "img/Lets-play-to-03.00d5de0e.jpg";